import { Link } from "react-router-dom";
import CountUp from "react-countup";
import Logo from "../../images/caobangceritage.svg"
import styles from "./Footer.module.css";

import inimg1 from "../../images/instragram/1.png";
import inimg2 from "../../images/instragram/2.png";
import inimg3 from "../../images/instragram/3.png";
import inimg4 from "../../images/instragram/4.png";
import inimg5 from "../../images/instragram/5.png";
import inimg6 from "../../images/instragram/6.png";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = (props) => {
  return (
    <footer className="wpo-site-footer">
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={Logo} alt="blog" />
                </div>
                <p>
                  CaoBangCeritage hoạt động với sứ mệnh kết nối văn hoá nghệ thuật truyền thống dân tộc tỉnh Cao Bằng.
                </p>
                {/* <h4>- Tham gia cùng chúng tôi</h4> */}
                {/* <div className="info">
                                    <h3>$<span><CountUp CountUp end={805684} enableScrollSpy /></span></h3>
                                </div> */}
              </div>
            </div>
            <div className="col col-lg-2 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Liên kết nhanh:</h3>
                </div>
                <ul>
                  {/* <li><Link onClick={ClickHandler} to="/contact">Về tác giả</Link></li> */}
                  {/* <li><Link onClick={ClickHandler} to="/events-single/1">Gặp gỡ Tình nguyện viên</Link></li> */}
                  <li>
                    <Link onClick={ClickHandler} to="/blog">
                      Nghiên cứu
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/image-ai">
                      Trí tuệ nhân tạo
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://vr.vabric.com.vn/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Khu trải nghiệm
                    </a>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Liên hệ
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-service-link-widget">
                <div className="widget-title">
                  <h3>Thông tin liên hệ</h3>
                </div>
                <div className="contact-ft">
                  <p>
                    Nếu bạn có bất kỳ thắc mắc nào, xin vui lòng liên hệ với
                    chúng tôi theo địa chỉ:
                  </p>
                  <ul>
                    <li>
                      <i className="fi flaticon-email"></i>caobangceritage@gmail.com
                    </li>
                    <li>
                      <i className="fi flaticon-phone-call"></i>+(84) 836.480.666
                    </li>
                    <li>
                      <i className="fi flaticon-phone-call"></i>+(84) 332.431.442
                  
                    </li>
                    <li>
                      <i className="fi flaticon-placeholder"></i>Cao Bằng
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget instagram">
                <div className="widget-title">{/* <h3>Projects</h3> */}</div>
                <ul className="d-flex">
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <img src={inimg1} alt="" className={`${styles.serviceCardWrapper}`}/>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <img src={inimg2} alt=""  className={`${styles.serviceCardWrapper}`}/>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <img src={inimg3} alt=""  className={`${styles.serviceCardWrapper}`}/>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <img src={inimg4} alt=""  className={`${styles.serviceCardWrapper}`}/>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <img src={inimg5} alt=""  className={`${styles.serviceCardWrapper}`}/>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <img src={inimg6} alt=""  className={`${styles.serviceCardWrapper}`}/>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="lower-wrap">
            <div className="row">
              <div className="col col-lg-6 col-12">
                <p className="copyright">
                  {" "}
                  Copyright &copy; 2025 caobangceritage. All Rights Reserved.
                </p>
              </div>
              <div className="col col-lg-6 col-12">
                <div className="social-icon">
                  <ul>
                    <li>
                      <Link onClick={ClickHandler} to="#">
                        <i className="ti-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="#">
                        <i className="ti-twitter-alt"></i>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="#">
                        <i className="ti-instagram"></i>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="#">
                        <i className="ti-google"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
